// extracted by mini-css-extract-plugin
module.exports = {"emptyCart":"truckCart_emptyCart__1r2Ke","buttonWrapper":"truckCart_buttonWrapper__FJqFz","truckCartWrapper":"truckCart_truckCartWrapper__1ozW0"};